<template>
    <div class="seccion-datos">
        <h4><i class="fas fa-user-friends icono-simple"></i> Contacto de Emergencia</h4>
        <div class="form-perfil">
            <div class="form-row">
                <div class="form-group">
                    <label><i class="fas fa-user"></i> Familiar Responsable</label>
                    <input
v-if="isEditing" v-model="perfilEditado.responsible_family_member"
                        type="text" class="form-control" placeholder="Ej. Juan Pérez" />
                    <p v-else class="form-value">
                        {{ perfilPaciente.responsible_family_member || 'No especificado' }}
                    </p>
                </div>
                <div class="form-group">
                    <label><i class="fas fa-heart"></i> Parentesco</label>
                    <input
v-if="isEditing" v-model="perfilEditado.family_member_relationship"
                        type="text" class="form-control" placeholder="Ej. Hermano" />
                    <p v-else class="form-value">
                        {{ perfilPaciente.family_member_relationship || 'No especificado' }}
                    </p>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label><i class="fas fa-phone-alt"></i> Contacto de Emergencia</label>
                    <input
v-if="isEditing" v-model="perfilEditado.emergency_contact" type="text"
                        class="form-control" placeholder="Ej. 555-1234" />
                    <p v-else class="form-value">
                        {{ perfilPaciente.emergency_contact || 'No especificado' }}
                    </p>
                </div>
                <div class="form-group">
                    <label><i class="fas fa-id-badge"></i> ID del Paciente</label>
                    <input
v-if="isEditing" v-model="perfilEditado.patient_identification"
                        type="text" class="form-control" placeholder="Ej. ID123456" />
                    <p v-else class="form-value">
                        {{ perfilPaciente.patient_identification || 'No especificado' }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, toRefs } from 'vue';

const props = defineProps({
    isEditing: {
        type: Boolean,
        default: false
    },
    perfilEditado: {
        type: Object,
        required: true
    },
    perfilPaciente: {
        type: Object,
        required: true
    }
});

const { isEditing, perfilEditado, perfilPaciente } = toRefs(props);
</script>

<style scoped>
.seccion-datos {
    margin-bottom: 2rem;
}

.seccion-datos h4 {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 0.75rem;
}

.icono-simple {
    color: #3b82f6;
    font-size: 1.1rem;
}

.form-perfil {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
}

.form-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-group label {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #64748b;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    gap: 0.35rem;
}

.form-group label i {
    font-size: 0.75rem;
    width: 0.85rem;
    text-align: center;
    color: #1e40af;
}

.form-value {
    font-size: 0.925rem;
    font-weight: 500;
    color: #1e293b;
    padding: 0.5rem 0;
    margin-top: 0;
    border: none;
    border-bottom: 1px solid rgba(15, 23, 42, 0.1);
    background: transparent;
    line-height: 1.4;
    letter-spacing: 0.15px;
    min-height: 2rem;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
}

.form-value:hover {
    border-bottom-color: rgba(30, 64, 175, 0.25);
    color: #0f172a;
}

.form-value:empty::before {
    content: "Sin registro";
    color: #cbd5e1;
    font-weight: 400;
    font-style: italic;
    font-size: 0.875rem;
}

@media (max-width: 768px) {
    .form-row {
        grid-template-columns: 1fr;
        gap: 1.25rem;
    }
}
</style>
